import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-arrow-up',
  templateUrl: './icon-arrow-up.component.html',
  styleUrls: ['./icon-arrow-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowUpComponent {}
